/*
 * @Author: 云逸 1832583130@qq.com
 * @Date: 2022-09-18 14:48:53
 * @LastEditors: 云逸 1832583130@qq.com
 * @LastEditTime: 2023-04-18 18:42:48
 * @FilePath: \tea-admin\src\api\modules\article.js
 * @Description:
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
// 资讯文章管理 article
import http from '../request.js'

export default {
  // 获取列表
  getList: data => {
    return http({
      url: '/api/news/list_server',
      data
    })
  },

  // 获取详情
  getInfo: data => {
    return http({
      url: '/api/news/get',
      data
    })
  },

  // 新增
  add: data => {
    return http({
      url: '/api/news/add',
      data
    })
  },

  // 编辑
  edit: data => {
    return http({
      url: '/api/news/edit',
      data
    })
  },

  // 修改状态
  edit_status: data => {
    return http({
      url: '/api/news/edit_status',
      data
    })
  },

  // 上下架发布
  updateStatus: data => {
    return http({
      url: '/api/user/goods_news_update',
      data
    })
  }
}
